
import CheckLine from '@/components/vectors/CheckLine.vue'
import { defineComponent } from 'vue'

export default defineComponent({
  components: {
    CheckLine
  }
})
